import * as Yup from "yup";

//REVISAR Y COMPLETAR AL MOMENTO DE CONECTAR CON MOBILE, CONOCER LAS VARIABLES Y TENER DISPONIBLES LOS ENDPOINTS

export const providersValidationSchema = Yup.object()
    .shape({
        channel: Yup.string().required("Requerido"),
        provider: Yup.string().required("Requerido"),
        providerCompanies: Yup.array()
        .of(Yup.number())
        .min(1, "Seleccione al menos una compañía")
        .required("Lista de compañías es requerido"),
    })
    .when((values, schema) => {
        switch (values.provider) {
            case "EMAIL.movistar":
                return schema.shape({
                    urlEMAILmovistar: Yup.string().matches(/^((https?:\/\/)|(www.))(?:([a-zA-Z]+)|(\d+\.\d+.\d+.\d+)):\d{4}$/,"La URL no es válida. Debe comenzar con 'http://', 'https://' o 'www', y ademas contener el número de puerto (ej. 'https://localhost:9090')").required("URL es requerido"),
                    templateSurveyEMAILmovistar: Yup.string().required("Template es requerido"),
                    descriptionEMAILmovistar: Yup.string().required("Descripción es requerido"),
                  });
                break;
            case "EMAIL.smtp":
                return schema.shape({
                    friendlyNameEMAILsmtp: Yup.string().required("Requerido"),
                    fromEMAILsmtp: Yup.string().required("Requerido"),
                    userEMAILsmtp: Yup.string().required("Requerido"),
                    passwordEMAILsmtp: Yup.string().required("Requerido"),
                    hostEMAILsmtp: Yup.string().required("Requerido"),
                    portEMAILsmtp: Yup.string().required("Requerido"),
                    sslEMAILsmtp: Yup.string().required("Requerido"),
                    tlsEMAILsmtp: Yup.string().required("Requerido"),
                    tlsProtocolEMAILsmtp: Yup.string().required("Requerido"),
                    authEnabledEMAILsmtp: Yup.string().required("Requerido"),
                    emailParserStrategyEMAILsmtp: Yup.string().required("Requerido"),
                    eventsEnabledEMAILsmtp: Yup.string().required("Requerido"),
                    descriptionEMAILsmtp: Yup.string().required("Descripción es requerido"),
                    });
                break;
            case "EMAIL.telefonica":
                return schema.shape({
                    templateSurveyEMAILtelefonica: Yup.string().required("Template es requerido"),
                    templateEmailEMAILtelefonica: Yup.string().required("Template es requerido"),
                    descriptionEMAILtelefonica: Yup.string().required("Descripción es requerido"),
                    });
                break;
            case "SMS.bitsense" || "SMS_REMINDER.bitsense":
                return schema.shape({
                    tokenSMSbitsense: Yup.string().required("Requerido"),
                    campaingSMSbitsense: Yup.string().required("Requerido"),
                    countrySMSbitsense: Yup.string().required("Requerido"),
                    regionSMSbitsense: Yup.string().required("Requerido"),
                    descriptionSMSbitsense: Yup.string().required("Descripción es requerido"),
                    });
                break;
            case "SMS.c3ntro" || "SMS_REMINDER.c3ntro":
                return schema.shape({
                    tokenSMSbitsense: Yup.string().required("Requerido"),
                    campaingSMSbitsense: Yup.string().required("Requerido"),
                    countrySMSbitsense: Yup.string().required("Requerido"),
                    regionSMSbitsense: Yup.string().required("Requerido"),
                    descriptionSMSbitsense: Yup.string().required("Descripción es requerido"),
                    });
                break;
            default:
                break                
        }
      });
    
      


  